import React from "react"
import { AppCardTitle, AppDataTable, AppResultsSkeleton, AppStartHint } from "@components"
import { offices } from "@signals"
import { isTableLoading, tableData } from "Pages/Admin/OfficeMapping/@signals"
import { actionsColumn, inputsColumn, siteColumn } from "Pages/Admin/OfficeMapping/Table/@columns"
import { useTableEdit } from "Pages/Admin/OfficeMapping/@hooks"


export default function OfficeMappingTable() {

	const { onSubmit } = useTableEdit()

	if (!tableData.value.length && !isTableLoading.value) return offices.value ? null : <AppStartHint
		icon="location-dot"
		title="Select a company and an office to start"
		description="Pick a company and one of its offices above to see its mapping"
	/>

	if (isTableLoading.value) return <AppResultsSkeleton/>


	return <AppDataTable
		title={<AppCardTitle icon="location-dot" title="Custom Offices Mapping"/>}
		data={tableData.value}
		columns={[siteColumn(), inputsColumn(), actionsColumn(onSubmit)]}
	/>
}